window.dispatchEvent(new CustomEvent('aiEvtJsStart'));
var providers = {
    dify: require('./modules/providers/dify')
};

var aiSearch = require('./ai-search');
module.exports = {
    providers: providers,
    aiSearch: aiSearch
};
